import { UtilHelper } from '../../../shared/helpers/utils.helper';
import { ProductRegisterType } from '../../category/products/enum/product-register-type.enum';
import { Complement } from '../../category/products/models/complement.model';
import { Rating } from '../../rating/models/rating.model';
import { OrderStatus } from '../enums/order-status.enum';

export class OrderItem {
	id: number;
	quantity: number;
	productId: number;
	productName: string;
	productType: ProductRegisterType;
	productRate: number;
	status: OrderStatus;
	total: number;
	note: string;
	complements: Array<Complement>;

	rated?: Rating; // usado para construir a tela para MOSTRAR A AVALIAÇÃO REALIZADA

	constructor(obj: any = { }) {
		Object.assign(this, obj);

		if (this.status != null && this.status['code'] == null) {
			this.status = UtilHelper.getEnumByCod(this.status, OrderStatus);

			if (this.status == null) {
				this.status = OrderStatus.UNDEFINED;
			}
		} else if (this.status == null) { // esse if aqui, em teoria nunca é para cair. Feito apenas por precaução
			this.status = OrderStatus.UNDEFINED;
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/pages/orders/models/order-item.model.ts